var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "16x16/Box") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.85673,4.69 L8.18673,2.01 L7.89327,2.01 L7.22327,4.69 L8.85673,4.69 Z M7.035,7.37 L9.045,7.37 L9.045,6.03 L7.035,6.03 L7.035,7.37 Z M5.695,6.03 L2.01,6.03 L2.01,13.73634 C2.01,13.91858 2.16209,14.07 2.34701,14.07 L13.73299,14.07 C13.91992,14.07 14.07,13.92059 14.07,13.73634 L14.07,6.03 L10.385,6.03 L10.385,8.04 C10.385,8.40984 10.08484,8.71 9.715,8.71 L6.365,8.71 C5.99516,8.71 5.695,8.40984 5.695,8.04 L5.695,6.03 Z M6.51173,2.01 L4.06958,2.01 L2.50647,4.69 L5.84173,4.69 L6.51173,2.01 Z M9.56827,2.01 L10.23827,4.69 L13.57353,4.69 L12.01042,2.01 L9.56827,2.01 Z M15.31285,5.01227 C15.37449,5.11411 15.41,5.2327 15.41,5.36 L15.41,13.73634 C15.41,14.66161 14.6596,15.41 13.73299,15.41 L2.34701,15.41 C1.42241,15.41 0.67,14.65893 0.67,13.73634 L0.67,5.36 C0.67,5.2327 0.70551,5.11411 0.76715,5.01227 L3.10612,1.00232 C3.22605,0.79663 3.44648,0.67 3.685,0.67 L12.395,0.67 C12.63352,0.67 12.85395,0.79663 12.97388,1.00232 L15.31285,5.01227 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02-Collab",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02.1-\\u2014-Collab-\\xB7-Default",
    transform: "translate(-384.000000, -1120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Listing-\\u2014-Latest-Files",
    transform: "translate(360.000000, 656.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "File_zip",
    transform: "translate(0.000000, 440.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DocType"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16x16/Box",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon",
    fill: "#000000",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxBlack);
export default __webpack_public_path__ + "static/media/Box_Black.875896657726127bdafdd6b927402abf.svg";
export { ForwardRef as ReactComponent };